export default __webpack_public_path__ + "54672c1f3ba121d804700bd6e76a8135.jpg";